import { useState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import * as styles from "../firstFlowModals/styles.css";
import { Icon, Icons } from "../../../atoms/icon";
import { Checkbox } from "../../../../components/atoms/checkbox";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import Strings from "../../../../utils/hardcoded.json";
export const AllAccessLandingPage = ({ onContinue, userProfileLength, hideAllAccessPopup, }) => {
    const [checked, onChangeValue] = useState(false);
    const toggleInput = () => {
        onChangeValue(!checked);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { label: Strings.ALL_ACCESS }, userProfileLength && userProfileLength < 2 ? (React.createElement("div", { className: styles.cardContainer, id: "pinValidationWrapper" },
            React.createElement("div", { className: styles.goBack, onClick: hideAllAccessPopup, id: "backArrow" },
                React.createElement(Icon, { type: Icons.LeftArrow, className: cn(styles.backArrow, styles.landingBackArrow), color: "white" })),
            React.createElement("div", { className: styles.wrapper, id: "allAccessImage" },
                React.createElement(Icon, { type: Icons.AllAccess, className: styles.image })),
            React.createElement("div", { className: styles.wrapper, id: "disclaimer" },
                React.createElement(Typography, { classNameM: M.of(styles.searchTypeHeading), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.ALL_ACCESS_DISCLAIMER))),
            React.createElement("div", { className: styles.confirmCard, id: "confirmationWrapper" },
                React.createElement(Checkbox, { checked: checked, onClick: toggleInput }),
                React.createElement(Typography, { classNameM: M.of(styles.searchTypeHeading1), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.CONFIRM))),
            React.createElement("div", { className: styles.buttonWrapper },
                React.createElement("div", { id: "continueButton" },
                    React.createElement(Button, { children: Strings.CONTINUE, variant: checked ? ButtonVariant.Primary : ButtonVariant.Disabled, onClickM: M.of(() => checked && onContinue()) }))))) : (React.createElement("div", { className: styles.shine })))));
};

